import { render, staticRenderFns } from "./AveineTranslatedField.vue?vue&type=template&id=0fb78500"
import script from "./AveineTranslatedField.vue?vue&type=script&lang=js"
export * from "./AveineTranslatedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports